__webpack_require__.p = "https://ads.wpcdn.pl/release-v1.461.1/public-desktop/";